import request from '../request';

export const getAllAccountData = async (params: any) => {
  const res = await request('get', '/api/SubscriberData/transaction-data', params);
  if (res.isSucceeded) {
    return res.data;
  }
};
